import { render, staticRenderFns } from "./AwardSetting.vue?vue&type=template&id=8ad715c2&scoped=true&"
var script = {}
import style0 from "./AwardSetting.vue?vue&type=style&index=0&id=8ad715c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad715c2",
  null
  
)

export default component.exports